<ion-content class="bg-color ion-content profile">
    <div class="com-content">
        <div class="content-breadcrumb">
            <ul class="breadcrumb">
                <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
                    <ng-container *ngIf="itemList.embedurl; else noRoute">
                        <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
                            {{ itemList.label }}
                        </a>
                    </ng-container>
                    <ng-template #noRoute>
                        <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
                            {{ itemList.label }}
                        </a>
                    </ng-template>

                </li>
            </ul>
        </div>
        <div class="content-grid">

            <mat-card class="m-content">
                <mat-card-title class="mc-title">
                    <span class="table-header">Enable Multi-Factor Authentication</span>
                </mat-card-title>
                <!-- </mat-card>
          <mat-card> -->
                <mat-card-content class="mc-content">
                    <mat-label>Register your mobile device to enable multi-factor authentication:</mat-label>
                    <mat-list role="list">
                        <mat-list-item role="listitem">1. Install Google/Oracle/Cisco Mobile Authenticator or a similar
                            authenticator app on your mobile device</mat-list-item>
                        <mat-list-item role="listitem">2. Open the app and add a new account. Scan the QR Code when
                            prompted</mat-list-item>
                        <p>
                            <img style="width:170px;margin-left: 150px;" [src]='qrCode.qr_code' />
                        </p>
                        <mat-list-item role="listitem">3. Enter the code displayed by the app:</mat-list-item>

                    </mat-list>
                    <form [formGroup]="multiFactorForm" (ngSubmit)="onSubmit()">
                        <p style="margin-left:25px">Verification code</p>
                        <div class="form-layout">

                            <mat-form-field appearance="fill" style="margin-left:25px">
                                <input type="text" matInput formControlName="verificationCode" placeholder="Enter the verification code generated by the authenticator app" (keydown)="checkLength2($event, inputText)" #inputText required>
                            </mat-form-field>
                        </div>
                        <div class="btn-signin-grid">

                            <!-- <button mat-raised-button type="submit" (click)="openSchedular()" class="btn-signin">Test</button> -->
                            <button mat-raised-button type="submit" class="btn btn-signin">Verify</button>
                            <button mat-raised-button type="reset" (click)="cancel()" class="btn" style="margin-left:15px">Cancel</button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>

        </div>
    </div>
</ion-content>